
import angular from 'angular';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { DatalayerConstantsType } from 'ib-web-commons/app/core/ib-datalayer/ib-datalayer-constants';

const controllerInfo = {
    module: 'ib-bob-modal-module',
    inject: ['$scope', '$uibModalInstance', 'localStorageService', 'DatalayerUtilsService', 'AncillariesConstants', 'DatalayerUtils', '$rootScope', 'CommonsConstants', 'CommonsUtilService', 'DatalayerConstants'],
    required: []
};


export class IbBobModalController implements ng.IController {
    public bobInfo = {};
    public isShowBobOrderSummary = false;
    public showBobOrderError = false;
    public bobOrder = {};
    public isLoading = false;
    constructor (private $scope: angular.IScope,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerUtils: DatalayerUtils,
        private $rootScope: CommonsRootScope,
        private CommonsConstants: CommonsConstantsType,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerConstants: DatalayerConstantsType) {

        this.$scope.$on('closeBobModal', this.close);
        this.$scope.$on('bobOrderCompleted', this.showBobOrderSummary);
    }


    $onInit (): void {
        const order = this.localStorageService.get('bobOrder');
        if (order) {
            this.bobOrder = order;
            this.isShowBobOrderSummary = true;
        }
        this.bobInfo = this.localStorageService.get('bobInfo');
        this.DatalayerUtils.bobEcommerceEventView();
    }

    updateDataLayerAndDigitalData = (): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
    };
    close = (): void => {
        const flow = this.localStorageService.get('flowApp');
        const specialUserBob = this.localStorageService.get('specialUserBob');
        const lastField = this.localStorageService.get('lastFieldBob');
        let label = '';
        let step = 1;
        if (this.showBobOrderSummary || this.showBobOrderError) {
            step = 2;
        }

        this.DatalayerUtilsService.updateDatalayerEvents(
            this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB_STEP,
            this.AncillariesConstants.DATALAYER_INFO.STEP + step,
            this.AncillariesConstants.DATALAYER_INFO.CANCEL,
            this.AncillariesConstants.DATALAYER_INFO.INTERACCION);

        if (this.showBobOrderError) {

            this.DatalayerUtilsService.updateDatalayerEvents(
                this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB_STEP,
                this.AncillariesConstants.DATALAYER_INFO.STEP + step,
                this.AncillariesConstants.DATALAYER_INFO.ERROR,
                this.AncillariesConstants.DATALAYER_INFO.INTERACCION);

        } else {
            if (lastField && !this.showBobOrderSummary) {
                label = this.AncillariesConstants.DATALAYER_INFO.LAST_FIELD_COMPLETE + lastField;
            } else if (this.showBobOrderSummary) {
                label = this.AncillariesConstants.DATALAYER_INFO.FINALIZE + (specialUserBob ? this.AncillariesConstants.DATALAYER_INFO.FREE : this.AncillariesConstants.DATALAYER_INFO.PAYMENT);
            }
            if (label !== '') {

                this.DatalayerUtilsService.updateDatalayerEvents(
                    this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB_STEP,
                    this.AncillariesConstants.DATALAYER_INFO.STEP + step,
                    label,
                    this.AncillariesConstants.DATALAYER_INFO.INTERACCION);
            }

        }
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        this.$uibModalInstance.dismiss('cancel');
        this.$scope.$broadcast('setModelStorage');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    showBobOrderSummary = (): void => {
        this.isShowBobOrderSummary = true;
    };

}
try {
    IbBobModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(IbBobModalController.name, IbBobModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    IbBobModalController.$inject = controllerInfo.inject;
    mod.controller(IbBobModalController.name, IbBobModalController);
}